import { httpApi } from "api/http.api";
import { IBulkSetupTemplate, IBulkSetupTemplatesResponse, IGarmentData, IHmacResponse, IRouteSiteResponse } from "domain/BulkSetup";
import moment from "moment";

export const getBulkSetupsList = (
  client_id: number
): Promise<IBulkSetupTemplate[]> =>
  httpApi
    .get<IBulkSetupTemplatesResponse>(`BulkSetups?client_id=${client_id}`)
    .then((response) => response.data.data);


export const getBulkSetupGerments = () =>
  httpApi
    .get<IGarmentData>("/Garments")
    .then((response) => response.data.data);

export const getBulkSetupRouteSiteByClient = (client_id: number) =>
  httpApi
    .get<IRouteSiteResponse>(`RouteSites/GetRouteSiteByClient/${client_id}`)
    .then((response) => response.data.data);

export const addShipment = (
  bulkSetupPayload: any
): Promise<any> =>
  httpApi
    .post<any>("BulkOrders/AddShipmentRecurrentBulkOrders", {
      ...bulkSetupPayload,
    })
    .then(({ data }) => data);

export const addBulkSetup = (
  bulkSetupPayload: IBulkSetupTemplate
): Promise<IBulkSetupTemplatesResponse> =>
  httpApi
    .post<IBulkSetupTemplatesResponse>("BulkSetups", {
      ...bulkSetupPayload,
    })
    .then(({ data }) => data);

export const editBulkSetup = (
  id: string,
  payload: IBulkSetupTemplate
): Promise<IBulkSetupTemplatesResponse> =>
  httpApi
    .put<IBulkSetupTemplatesResponse>("BulkSetups/" + id, {
      ...payload,
    })
    .then(({ data }) => data);


export const deleteBulkSetups = async (
  bulk_setups_id: number
) => {
  const time = moment().toISOString();

  const hmacTokenResponse = await httpApi.delete<IHmacResponse>(
    `BulkSetups/${bulk_setups_id}`,
    {
      data: { hmac_time: time },
    }
  );

  const hmac = hmacTokenResponse.data.hmac;

  return httpApi
    .delete<IBulkSetupTemplatesResponse>(
      `BulkSetups/${bulk_setups_id}`,
      {
        data: {
          hmac_time: time,
          hmac,
        },
      }
    )
    .then((res) => res.data);
};

export const getBulkSetupsById = (id: number | string): Promise<IBulkSetupTemplate> =>
  httpApi
    .get<{ data: IBulkSetupTemplate[] }>(`BulkSetups/${id}`)
    .then(({ data }) => data.data[0])
    .then((data) => data);